export function statusTextForOrder(order: sage.model.IOrder): string {
    switch (order.state) {
        case "CANCELLED":
            return "Cancelled";
        case "ERROR":
            return "Error";
        case "FULFILLED":
            return "Fulfilled";
        case "OPEN":
            return "Open";
        case "PARTIALLY_FULFILLED":
            return "Partially Fulfilled";
    }
}

export function colorClassForOrder(order: sage.model.IOrder): string {
    switch (order.state) {
        case "OPEN":
        case "CANCELLED":
            return "secondary";
        case "PARTIALLY_FULFILLED":
            return "primary";
        case "FULFILLED":
            return "success";
        case "ERROR":
            return "danger";
    }
}
